/** Derived from the location's KDS flows: a flow station's position along its flow
 * (0 = first), used to order an order line's progress chips in the station detail sheet. */
export type FlowGraph = {
  depthByFlowStationId: Map<number, number>;
};

export const EMPTY_FLOW_GRAPH: FlowGraph = {
  depthByFlowStationId: new Map(),
};

// Re-export generated types so existing local imports keep resolving.
export type { ExpoView, ExpoOrder, ExpoDisplayItem, ExpoChip, ExpoChipState, ItemTotal } from '@ordr-as/ordr-service-types/epos';
